import { render } from "./ShareResultButton.vue?vue&type=template&id=40771e1b&ts=true"
import script from "./ShareResultButton.vue?vue&type=script&lang=ts"
export * from "./ShareResultButton.vue?vue&type=script&lang=ts"

import "./ShareResultButton.vue?vue&type=style&index=0&id=40771e1b&lang=scss"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__